import React, { useState } from 'react';

// Material
import Box from '@material-ui/core/Box';

// Constants
import { ALLCOLORS } from 'constants/hexagonoColors';

// Styles
import useStyles from './styles';

interface HexagonoPickColorInterface {
  setState: (param: string) => void;
  colorSelected: string;
}

const HexagonoPickColor: React.FC<HexagonoPickColorInterface> = ({
  setState,
  colorSelected,
}) => {
  const classes = useStyles();

  const [currColor, setCurrColor] = useState<string>(colorSelected);

  const hex = { unicode: '⬢', color: '' };
  let n = 0;
  let hexNums = [5, 6, 7, 8];
  let hexArrs = [];
  let hexNum;
  for (hexNum of hexNums) {
    let hexArr = [];
    for (n = 0; n < hexNum; n++) hexArr.push(hex);
    hexArrs.push(hexArr);
  }
  let hexArr = [];
  for (n = 0; n < 9; n++) hexArr.push(hex);
  hexArrs.push(hexArr);
  hexArr = [];
  let hexNums2 = JSON.parse(JSON.stringify(hexNums));
  hexNums2.reverse();
  for (hexNum of hexNums2) {
    hexArr = [];
    for (n = 0; n < hexNum; n++) hexArr.push(hex);
    hexArrs.push(hexArr);
  }

  let currSizeLine = 0;
  let BeforeSizeLine = 0;
  const hexAarrsColored = hexArrs.map((hexArrLine, index: number) => {
    if (index !== 0) {
      currSizeLine += BeforeSizeLine;
    }
    BeforeSizeLine = hexArrLine.length;
    return hexArrLine.map((hexItem, i: number) =>
      !hexItem.color
        ? { ...hexItem, color: ALLCOLORS[currSizeLine + i] }
        : hexItem,
    );
  });

  const getTextStroke = (color: string) => {
    if (currColor === color) {
      return color === '#FFFFFF' ? '1px #000' : '1px';
    }
    return `9px ${color}`;
  };

  return (
    <Box className={classes.content}>
      <div className='hexColorPicker'>
        <div id='output' className='noselect'>
          {hexAarrsColored.map((hexArrLine) => {
            return (
              <span className='condensed-line'>
                {hexArrLine.map((hexItem) => {
                  return (
                    <>
                      <span
                        onClick={() => {
                          setState(hexItem.color);
                          setCurrColor(hexItem.color);
                        }}
                        style={{
                          color: hexItem.color,
                          WebkitTextFillColor: hexItem.color,
                          WebkitTextStroke: getTextStroke(hexItem.color),
                        }}
                        className='colorHex'>
                        {currColor === hexItem.color && (
                          <svg
                            className='ornamentSvg'
                            width='11'
                            height='12'
                            viewBox='0 0 11 12'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'>
                            <rect
                              y='0.5'
                              width='11'
                              height='11'
                              rx='3'
                              fill={
                                hexItem.color !== '#FFFFFF' ? 'white' : 'black'
                              }
                            />
                            <path
                              d='M3 6L4.5 7.5L7.5 4.5'
                              stroke={hexItem.color}
                            />
                          </svg>
                        )}
                        {hexItem.unicode}
                      </span>
                    </>
                  );
                })}{' '}
              </span>
            );
          })}
        </div>
      </div>
    </Box>
  );
};

export default HexagonoPickColor;
export { HexagonoPickColor };
